import { useContext } from 'react';
import { Editor, useEditorState } from '@tiptap/react';

import DocumentContext from '../contexts/DocumentContext.context';
import { shallowEqual } from '@shared/helpers';

const useEditorActive = <T,>(evaluate: (editor: Editor) => T, fallbackValue?: T): T => {
  const editor = useContext(DocumentContext)?.editor ?? null;

  return useEditorState({
    editor,
    // Some cross-item surfaces (for example the global AI overlay) render outside
    // DocumentProvider. Keep the hook usable there without invoking an evaluator
    // that requires an editor.
    selector: ({ editor: currentEditor }) => (currentEditor ? evaluate(currentEditor) : fallbackValue),
    equalityFn: shallowEqual,
  }) as T;
};

export default useEditorActive;
